// LinkedIn-style tenure, e.g. "2 yrs 2 mos", "1 yr", "8 mos" (inclusive of the current month).
//
// Every date part is read in UTC. The resume is server-rendered on a UTC box and
// hydrated in the visitor's own zone, so a local getMonth() rolls a month early for
// anyone east of UTC and late for anyone west; the server would render "1 yr 2 mos"
// and the client "1 yr 3 mos", which is the React #418 hydration mismatch that was
// firing on resume.gazar.dev. The sibling month/year label was already pinned to UTC
// for this reason and this function was missed, so it lives here with a test on it.
export function tenure(
  job: { startdate: string; enddate: string | null; current: boolean },
  now: Date = new Date(),
): string {
  const s = new Date(job.startdate);
  const e = job.current || !job.enddate ? now : new Date(job.enddate);
  let months =
    (e.getUTCFullYear() - s.getUTCFullYear()) * 12 + (e.getUTCMonth() - s.getUTCMonth()) + 1;
  if (months < 1) months = 1;
  const y = Math.floor(months / 12);
  const m = months % 12;
  const yPart = y > 0 ? `${y} yr${y > 1 ? "s" : ""}` : "";
  const mPart = m > 0 ? `${m} mo${m > 1 ? "s" : ""}` : "";
  return [yPart, mPart].filter(Boolean).join(" ");
}
